export const keyAttributeTypeId = 'ID';
